import styled from 'styled-components';

export const Page = styled.div`
  padding: 5px;
  height: 100%;
  padding-bottom: 100px;
  text-align: center;
  .ant-row {
    justify-content: center;
  }
`;

export const Imagem = styled.img`
  padding: 5px;
  margin: auto;
  width: 60vh;
`;

export const Titulo = styled.h1`
  font-size: 50pt;
  font-size: calc(var(--font-tamanho) + 38pt);
  font-weight: 600;
  color: var(--primary-color-sefaz);
  margin-bottom: 0;
`;

export const Subtitulo = styled.p`
  font-size: 25pt;
  font-size: calc(var(--font-tamanho) + 13pt);
  font-weight: 500;
  padding: 0 0 10px 0;
  color: var(--primary-color-sefaz);
  margin-bottom: 0;
  margin-top: -21px;
`;

export const Descricao = styled.p`
  width: 80%;
  margin: auto;
  padding: 5px;
  padding-top: 0px;
  color: var(--texto-color);
  font-size: var(--font-tamanho);
`;
